<div class="d-flex floor-plan-container">
  <div class="floor-plan" id="myPlot" #myPlot [hidden]="!showGraph ">
    <ng-container>
      <div *ngIf="!plotComplete" class="loader">
        <svg>
          <symbol id="loader-text">
            <text x="50%" y="50%" text-anchor="middle">Loading Floor Plan...</text>
          </symbol>
          <g class="g-ants">
            <use xlink:href="#loader-text" class="text-copy"></use>
            <use xlink:href="#loader-text" class="text-copy"></use>
            <use xlink:href="#loader-text" class="text-copy"></use>
            <use xlink:href="#loader-text" class="text-copy"></use>
            <use xlink:href="#loader-text" class="text-copy"></use>
          </g>
        </svg>
      </div>
    </ng-container>
  </div>
  <div [hidden]="showGraph" class="no-records">
    <div class="d-flex justify-content-center align-items-center vh-75">
      <div class="text-center image-style">
        <img src="../../../assets/images/nodata.svg" class="w-100" alt="no-data">
      </div>
    </div>
  </div>
  <div class="floor-plan-table">
    <div class="dropdown-container">
      <mat-form-field appearance="outline" class="floor-plan-dropdown">
        <mat-label>Zone Name</mat-label>
        <mat-select [disableOptionCentering]="true" [formControl]="selectedZone" (selectionChange)="changeZone()">
          <mat-option class="text-capitalize" *ngFor="let option of zoneNames" [value]="option.name" selected>
            {{option.name}}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <app-search (searchItem)="searchOnChange($event)" [pageType]='pageType' *ngIf="showGraph"></app-search>
    </div>
    <div class="floor-plan-details" *ngIf="showGraph">
      <!--/////// Mapped entity details ///////-->
      <div class="mapped-entity-selected ">
        <div class="floor-plan-text">
          <span (click)="toggle()" [ngClass]="toggleView?'mapped-entity-text':'unselected-text'">Tagged Assets </span>
          <span class="mapped-text-divider">|</span>
          <span (click)="toggle()" [ngClass]="[!toggleView?'mapped-entity-text':'unselected-text', viewToggle? 'disabled': '']"> Untagged
            Assets</span>
        </div>

        <div class="mapped-entity-container" *ngIf="toggleView">
          <div class="mapped-container-section">

            <div
              [ngClass]="isAdd && editedEntityId === entity?.entityId ? 'mapped-entity-container-row mapped-edit-icon-select-initial':'mapped-entity-container-row'"
              *ngFor="let entity of mappedEntities; let i = index ">
              <div class="entity-details-container">
                <span class="entity-text">{{entity?.uniqueId}}
                  <a  class="edit-icon" *ngIf="entity?.alertCount>0">
                    <img src="../../assets/images/ActiveAlerts 1.svg" alt="alert-icon">
                  </a>
                </span>
                <span class="entity-details"><strong>Last Active</strong> {{entity?.lastSeentime}}</span>
              </div>
              <div class="mapped-entity-icon" *ngIf="!isAdd">
                <a (click)="viewMarker(i,entity?.entityId)" class="edit-icon" matTooltip="View Marker Location">
                  <img src="../../assets/images/eye-view-idec.svg" alt="edit-icon">
                </a>
                <a (click)="editMarker(i,entity?.entityId)" class="edit-icon" matTooltip="Edit Marker Location">
                  <img src="../../assets/images/edit_location_alt.svg" alt="edit-icon">
                </a>
                <a (click)="checkIfDelete(entity?.entityId)" class="delete-icon" matTooltip="Untag Marker">
                  <img src="../../assets/images/label_off.svg" alt="delete-icon">
                </a>
              </div>
              <div class="mapped-entity-icon" *ngIf="isAdd && isview && editedEntityId === entity?.entityId">
                <a (click)="viewMarker(i,entity?.entityId)" class="edit-icon" matTooltip="Exit View Mode">
                <img src="../../assets/images/eye-hide.svg" alt="edit-icon">
              </a>
              </div>
              <div class="mapped-entity-icon" *ngIf="isAdd && editedEntityId === entity?.entityId && !isview">
                <a [ngClass]="{'disabled-accept':!applyMarker}" (click)="updateEntityCoordinates()">
                  <img class="tick-icon"
                    [src]="!applyMarker ? '../../assets/images/Group 427319328.svg':'../../assets/images/Group 427319328 (3).svg'"
                    alt="tick-icon">
                </a>
                <a (click)="cancelEdit()" class="cross-icon">
                  <img src="../../assets/images/Group 427319330.svg" alt="cross-icon">
                </a>
              </div>
            </div>
          </div>
        </div>

        <div class="available-details-container" *ngIf="!toggleView">
          <div class="available-details-section">
            <div
              [ngClass]="isAdd && editedEntityId === entity?.entityId?'available-details available-plus-icon-select':'available-details'"
              *ngFor="let entity of availableEntities ; let i = index">
              <a *ngIf="!isAdd">
                <img src="../../assets/images/ic_outline-plus.svg" alt="outline-plus" class="outline-plus-img" matTooltip="Tag Asset"
                  (click)="addDevice(i,entity.entityId)">
              </a>
              <div class="available-entity-data">
                <span class="entity">{{entity?.uniqueId}}
                  <a  class="edit-icon" *ngIf="entity?.alertCount>0">
                    <img src="../../assets/images/ActiveAlerts 1.svg" alt="alert-icon">
                  </a>
                </span>
                <span class="entity-data"><strong>Last Active</strong> {{entity?.lastSeentime}}</span>
              </div>
              <div class="available-entity-icon" *ngIf="isAdd && editedEntityId === entity?.entityId">
                <a [ngClass]="{'disabled-accept':!applyMarker}" (click)="updateEntityCoordinates()">
                  <img
                    [src]="!applyMarker ? '../../assets/images/Group 427319328.svg':'../../assets/images/Group 427319328 (3).svg'"
                    alt="tick-icon">
                </a>
                <a (click)="cancelMapping()" class="cross-icon">
                  <img src="../../assets/images/Group 427319330.svg" alt="cross-icon">
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>